<script setup>
import {computed, ref} from "vue";

const props = defineProps({
    settings: {
        type: Object,
        required: false,
    },
    domain: {
        type: String,
        default: '',
        required: false,
    },
})
const wrapStyles = computed(() => {
    if (props.settings.view_settings.avatar_transparent_border && props.settings.view_settings.root_btn_type === 'photo') {
        return {
            height: `${1.25 * props.settings.view_settings.avatar_size}px`,
            width: `${1.25 * props.settings.view_settings.avatar_size}px`,
            position: 'relative',
        };
    }
    return {
        height: `${props.settings.view_settings.avatar_size}px`,
        width: `${props.settings.view_settings.avatar_size}px`,
        position: 'relative',
    }
})
const rootBtnStyles = computed(() => {
    let res = {
        height: `${props.settings.view_settings.avatar_size}px`,
        width: `${props.settings.view_settings.avatar_size}px`,
        borderRadius: '100%',
    };

    if (props.settings.view_settings.root_btn_type === 'photo') {
        res['border-style'] = 'solid';
        res['border-width'] = '2px';
        res['border-color'] = props.settings.view_settings.avatar_border_color;
        res['background'] = props.settings.view_settings.avatar_background_color;
        if (props.settings.view_settings.avatar_transparent_border) {
            res['border-style'] = 'none';
            res['backdrop-filter'] = 'blur(4px)';
            res['background'] = 'radial-gradient(58.77% 68.75% at 50% 100%,' + props.settings.view_settings.avatar_background_color + ' 20%, '+props.settings.view_settings.avatar_background_color+'4D';
        }
    }

    return res;
});
function getImage() {
    if (props.settings.view_settings.root_btn_type === 'animated-icon') {
       if (props.settings.messengers_settings.tg_enabled && props.settings.messengers_settings.wa_enabled) {
           return props.domain + '/social-widget/img/root-btn-anim-tg-wa.gif';
       }
       if (props.settings.messengers_settings.tg_enabled) {
           return props.domain + '/social-widget/img/root-btn-anim-tg.gif';
       }
       if (props.settings.messengers_settings.wa_enabled) {
           return props.domain + '/social-widget/img/root-btn-anim-wa.gif';
       }
    }
    if (props.settings.view_settings.root_btn_type === 'static-icon') {
        if (props.settings.messengers_settings.wa_enabled) {
            return props.domain + '/social-widget/img/root-btn-wa.png';
        } else {
            return props.domain + '/social-widget/img/root-btn-tg.png'
        }
    }
    if (props.settings.view_settings.root_btn_type === 'photo') {
        return props.settings.view_settings.avatar_url;
    }
}

const showOline = ref(false);

setInterval(checkWorkingTime, 1000);
function checkWorkingTime() {
    const currentDate = new Date();
    let weekDay = currentDate.getDay();

    if (props.settings.view_settings.daysTimes[weekDay].workingDay) {
        let currentTime = currentDate.getHours()+''+currentDate.getMinutes();
        let startTime = props.settings.view_settings.daysTimes[weekDay].startTime.replace(':','');
        let endTime = props.settings.view_settings.daysTimes[weekDay].endTime.replace(':','');

        showOline.value = startTime <= currentTime && endTime >= currentTime;

    } else {
        showOline.value = false;
    }
}

</script>

<template>
<div :class="{'dg__sw-avatar-wrap' : settings.view_settings.avatar_transparent_border && settings.view_settings.root_btn_type === 'photo'}"
     :style="wrapStyles">

        <img :style="rootBtnStyles"
             :src="getImage()"

             alt="avatar">
    <div v-if="settings.view_settings.online && showOline && settings.premium"
        class="online-animation"></div>


</div>
</template>

<style scoped>

</style>
